import React from "react";
import { Group, Paper } from "@mantine/core";
import { HiPlus, HiOutlineFunnel } from "react-icons/hi2";
import CustomSearchBar from "../../ui/CustomSearchBar/CustomSearchBar";
import CustomSelect from "../../ui/CustomSelect/CustomSelect";
import { CustomText } from "../../ui/CustomText/CustomText";
import CustomButton from "../../ui/CustomButton/CustomButton";
import { optionsFilterByLabel } from "../../../utils/optionsFilter";
import useMerchantSegmentOptions from "../hooks/useMerchantSegmentOptions";

const MerchantFilters = ({
  searchQuery,
  onSearchChange,
  segment,
  onSegmentChange,
  onAddMerchant,
  disabled = false,
}) => {
  const {
    optionsWithAll: segmentOptions,
    isLoading: segmentOptionsLoading,
    isError: segmentOptionsError,
    hasOptions: hasSegmentOptions,
  } = useMerchantSegmentOptions();

  let segmentSelectTitle = "";
  if (segmentOptionsError) {
    segmentSelectTitle = "Cannot select: failed to load segments";
  } else if (!segmentOptionsLoading && !hasSegmentOptions) {
    segmentSelectTitle = "Cannot select: no segments available";
  }

  return (
    <div className="flex-shrink-0">
      <Group justify="space-between" align="flex-end" className="mb-4">
        <div>
          <CustomText c="dimmed" size="sm" mt={4}>
            Create and manage merchants
          </CustomText>
        </div>
        <CustomButton onClick={onAddMerchant} leftSection={<HiPlus size={16} />}>
          Add Merchant
        </CustomButton>
      </Group>
      <Paper p="md" withBorder>
        <Group align="flex-start" wrap="wrap">
          <CustomSearchBar
            placeholder="Search merchants..."
            onSearchChange={onSearchChange}
            value={searchQuery}
            debounceDelay={500}
            disabled={disabled}
          />
          <CustomSelect
            data={segmentOptions}
            value={segment ?? ""}
            onChange={(v) => onSegmentChange?.(v || "")}
            leftSection={<HiOutlineFunnel color="gray" size={14} />}
            searchable
            comboboxProps={{ withinPortal: false }}
            filter={optionsFilterByLabel}
            placeholder="All Merchant Types"
            title={segmentSelectTitle}
            size="md"
            style={{ width: 220 }}
            disabled={
              disabled ||
              segmentOptionsLoading ||
              segmentOptionsError ||
              !hasSegmentOptions
            }
          />
        </Group>
      </Paper>
    </div>
  );
};

export default MerchantFilters;
